export const CLUB_BILLING_CURRENCIES = Object.freeze(["SEK", "EUR", "BRL", "USD"]);

export function normalizeBillingCurrency(value, fallback = "SEK") {
  const raw = String(value || fallback)
    .trim()
    .toUpperCase()
    .slice(0, 3);
  if (CLUB_BILLING_CURRENCIES.includes(raw)) return raw;
  return CLUB_BILLING_CURRENCIES.includes(String(fallback).toUpperCase().slice(0, 3))
    ? String(fallback).toUpperCase().slice(0, 3)
    : "SEK";
}

const LOCALE_BY_CURRENCY = {
  SEK: "sv-SE",
  EUR: "de-DE",
  BRL: "pt-BR",
  USD: "en-US",
};

/**
 * @param {import("i18next").TFunction} t
 * @param {string} [language]
 * @param {unknown} amount
 * @param {string} [currency]
 */
export function formatClubMoney(t, language, amount, currency = "SEK") {
  const n = Number(amount);
  if (Number.isNaN(n)) return t("finance_placeholder_dash");
  const code = normalizeBillingCurrency(currency);
  const locale =
    LOCALE_BY_CURRENCY[code] ||
    (language?.startsWith("en") ? "en-GB" : language?.startsWith("pt") ? "pt-BR" : "sv-SE");
  try {
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency: code,
      maximumFractionDigits: code === "BRL" ? 2 : 0,
      minimumFractionDigits: code === "BRL" ? 2 : 0,
    }).format(n);
  } catch {
    const formatted = new Intl.NumberFormat(locale, { maximumFractionDigits: 0 }).format(n);
    return t("finance_amount_with_currency", { amount: formatted, currency: code });
  }
}
